import React, { useState } from "react";
import * as Icons from "@/assets/features/requistion";
import ExportDialog from "@/components/shared/comman/modals/ExportModal";
import InputField from "@/components/shared/inputs/InputField";
import { X } from "lucide-react";
import { REQUISITION_FILTER_MODAL_KEYS } from "../../constant/constant";
import { useNavigate } from "react-router-dom";

const Filters = ({history=true}) => {
  const [activeModal, setActiveModal] = useState(REQUISITION_FILTER_MODAL_KEYS.NONE);
  const [search, setSearch] = useState(false);
const navigate = useNavigate();
  const closeModal = () => setActiveModal(REQUISITION_FILTER_MODAL_KEYS.NONE);

  return (
    <>
      <div className="flex items-center">
        {/* ============= Action Buttons / Search Bar ============= */}
        <div className="flex flex-wrap items-center justify-end gap-3 text-sm text-secondary">
          {search ? (
            <>
              {/* Search Input Field */}
              <div className="relative mt-4 w-full">
                <InputField
                  className="mb-4 px-8 !w-full rounded-[16px] shadow-light-sm"
                  placeholder="Search..."
                  onChange={(e) => {}}
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 cursor-pointer"
                  onClick={() => setSearch(false)}
                >
                  <X className="h-5 w-5" />
                </button>
                <button
                  type="button"
                  className="absolute left-3 top-2.5 text-gray-500"
                  onClick={() => {
                  }}
                >
                  <Icons.Search
                    className="h-4 w-4"
                    color="var(--color-blue-300)"
                  />
                </button>
              </div>
            </>
          ) : (
            <>
              {/* Export Dropdown */}
              <div
                className="flex items-center gap-1.5 mx-2 text-sm text-secondary font-medium cursor-pointer"
                onClick={() =>
                  setActiveModal(REQUISITION_FILTER_MODAL_KEYS.EXPORT)
                }
              >
                <Icons.Export className="w-4 h-4" />
                Export as
              </div>
              {/* view history */}
              {history&& <div
                className="flex items-center capitalize gap-1.5 mx-2 text-sm text-secondary font-medium cursor-pointer  shadow-light-sm rounded-full p-2"
                onClick={() =>
                  navigate('history')
                }
              >
                <Icons.History className="w-4 h-4" />
                view history{" "}
              </div>}
             
              {/* Search Toggle */}
              <div
                className="shadow-light-sm rounded-full p-2"
                onClick={() => setSearch(true)}
              >
                <Icons.Search className=" h-5 w-5 " />
              </div>

              {/* Filter */}
              <div
                size="sm"
                className="gap-2 border-none text-sm text-secondary font-medium flex items-center shadow-light-sm rounded-full px-4 py-2"
              >
                <Icons.Filter className="w-4 h-4" />
                Filter
              </div>
            </>
          )}
        </div>
      </div>

      {/* =========== Modals (Controlled by activeModal) ======== */}

      <ExportDialog
        open={activeModal === REQUISITION_FILTER_MODAL_KEYS.EXPORT}
        onOpenChange={closeModal}
      />
    </>
  );
};

export default Filters;
